// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [user, setUser] = useState(initialUser || null);
//   const [userProfile, setUserProfile] = useState(initialUserProfile || null);
//   const navigate = useNavigate();

//   const getInitials = (user) => {
//     if (!user) return "";
//     if (user.firstName && user.lastName)
//       return user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase();
//     if (user.name)
//       return user.name.charAt(0).toUpperCase() + user.name.charAt(user.name.length - 1).toUpperCase();
//     return "";
//   };

//   const handleLogoutClick = () => {
//     localStorage.removeItem("auth");
//     setUser(null);
//     setUserProfile(null);
//     if (handleLogout) handleLogout();
//     navigate("/login");
//   };

//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       try {
//         const parsed = JSON.parse(auth);
//         const storedUser = parsed?.user;
//         if (storedUser) {
//           setUser(storedUser);
//           setUserProfile(storedUser);
//         }
//       } catch (error) {
//         console.error("Invalid auth data:", error);
//       }
//     }
//   }, []);

//   const serviceArea = [
//     { name: "Slough", url: "/slough" },
//     { name: "Hayes", url: "/hayes" },
//     { name: "Hunslow", url: "/hunslow" },
//     { name: "Southall", url: "/southall" },
//     { name: "Uxbridge", url: "/uxbridge" },
//     { name: "Greenford", url: "/greenford" },
//     { name: "Northolt", url: "/northolt" },
//     { name: "Windsor", url: "/windsor" },
//     { name: "Ruislip", url: "/ruislip" },
//     { name: "Harrow", url: "/harrow" },
//     { name: "Maidenhead", url: "/maidenhead" },
//     { name: "High Wycombe", url: "/highwycombe" },
//   ];

//   const aboutSection = [
//     { name: "FAQs", url: "/faq" },
//     { name: "Blog", url: "/blog" },
//     { name: "Terms & Conditions", url: "/termsandconditions" },
//   ];

//   const products = [
//     { name: "Blind", url: "/blinds" },
//     { name: "Carpet", url: "/carpets" },
//     { name: "Furniture", url: "/furniture" },
//     // { name: "Sofa", url: "/sofa" },
//   ];

//   const clientPortal = user
//     ? [
//       userProfile?.role === "user" ? { name: "Book Now", url: "/book" } : null,
//       { name: "Logout", action: handleLogoutClick },
//     ].filter(Boolean)
//     : [
//       { name: "Login", url: "/login" },
//       { name: "Register", url: "/register" },
//     ];

//   const navLinks = [
//     { name: "Service Areas", dropdown: serviceArea },
//     { name: "Products", dropdown: products },
//     { name: "About", dropdown: aboutSection },
//     { name: "Client Portal", dropdown: clientPortal },
//     { name: "Contact Us", url: "/contact" },
//   ];
  

//   return (
//     <>
//       {/* Top Bar */}
//       <div className="w-full bg-lime-700 text-white py-2 px-4 sm:px-8 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0 text-xs sm:text-sm md:text-base font-semibold tracking-wide font-heading">
//         <div className="flex items-center gap-3">
//           {/* <a
//       href="https://wa.me/447405264139"
//       target="_blank"
//       rel="noopener noreferrer"
//       className="flex items-center gap-2 hover:opacity-90 transition"
//       aria-label="Call or WhatsApp"
//     >
//       <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//         <path d="M22 16.92V21a1 1 0 0 1-1.11 1 19 19 0 0 1-8.63-3.07 19 19 0 0 1-6-6A19 19 0 0 1 2 3.11 1 1 0 0 1 3 2h4.09a1 1 0 0 1 1 .75c.12.75.33 1.48.63 2.18a1 1 0 0 1-.24 1.04L7.7 8.7a15 15 0 0 0 6 6l1.72-1.72a1 1 0 0 1 1.04-.24c.7.3 1.43.51 2.18.63a1 1 0 0 1 .75 1V21z"></path>
//       </svg>
//       <span className="leading-none">+44 7405 264139</span>
//     </a> */}


//         </div>

//         <div className="flex items-center gap-3">
//           <span className="text-sm text-white/90">Serving Greater London Area</span>
//           <a href="/contact" className="ml-2 inline-flex items-center px-2 py-2 bg-white text-lime-700 rounded text-xs font-medium shadow-sm hover:opacity-95 transition">
//             Get a Quote
//           </a>
//         </div>
//       </div>

//       {/* Navbar */}
//       <nav className="w-full bg-white shadow-md sticky top-0 z-50">
//         <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8">
         
//           <Link to="/" className="flex items-center space-x-3">
//           <img
//     src="/images/logi.png"
//               // 💡 RESPONSIVE CLASSES: 
//               // Default width (mobile first) is w-24, increasing at sm, md, and lg breakpoints.
//               className="w-28 h-28 object-contain"
//             />
//             {/* <div className="absolute inset-0 "></div> */}
//             {/* </div> */}
//           </Link>

//           {/* Desktop Menu */}
//           <ul className="hidden md:flex space-x-6 lg:space-x-8 items-center mx-auto text-sm md:text-base lg:text-lg">
//             {navLinks.map((link, idx) => (
//               <li key={idx} className="relative group">
//                 {link.dropdown ? (
//                   <>
//                     <button className="text-gray-900 hover:text-lime-500 font-medium flex items-center gap-1 transition-all duration-300">
//                       {link.name}
//                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </button>
//                     <ul className="absolute top-full left-0 hidden group-hover:block bg-white border border-lime-500 shadow-lg rounded-md w-44 z-50">
//                       {link.dropdown.map((item, id) => (
//                         <li key={id}>
//                           {item.url ? (
//                             <Link
//                               to={item.url}
//                               className="block px-4 py-2 text-sm text-gray-900 hover:bg-lime-500 hover:text-white transition-all duration-300"
//                             >
//                               {item.name}
//                             </Link>
//                           ) : (
//                             <button
//                               onClick={item.action}
//                               className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-lime-500 hover:text-white transition-all duration-300"
//                             >
//                               {item.name}
//                             </button>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   </>
//                 ) : (
//                   <Link to={link.url} className="text-gray-900 hover:text-lime-500 font-medium transition-all duration-300">
//                     {link.name}
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>

//           {/* Right Side (Mobile Hamburger and Profile) */}
//           <div className="flex items-center space-x-2 sm:space-x-3">
//             {user ? (
//               <Link to="/profile" className="flex items-center justify-center">
//                 {userProfile?.avtar ? (
//                   <img src={userProfile.avtar} alt="Profile" className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full border-2 border-lime-500 object-cover" />
//                 ) : (
//                   <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full border-2 border-lime-500 bg-lime-500 text-white font-bold text-xs sm:text-sm md:text-base">
//                     {getInitials(userProfile || user)}
//                   </div>
//                 )}
//               </Link>
//             ) : (
//               <>
//                 <Link to="/login" className="px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm md:text-base rounded-md text-black border border-lime-500 hover:bg-lime-500 hover:text-gray-900 transition-all duration-300">
//                   Login
//                 </Link>
//                 <Link to="/register" className="px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm md:text-base rounded-md bg-lime-500 text-gray-900 hover:bg-lime-400 transition-all duration-300">
//                   Signup
//                 </Link>
//               </>
//             )}
//             <button
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//               className="md:hidden text-lime-500 focus:outline-none ml-2"
//             >
//               <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMobileMenuOpen && (
//           <div className="md:hidden bg-white text-gray-900 flex flex-col px-6 py-4 space-y-3 text-sm sm:text-base">
//             {navLinks.map((link, idx) => (
//               <div key={idx}>
//                 {link.dropdown ? (
//                   <details>
//                     <summary className="cursor-pointer hover:text-lime-500">{link.name}</summary>
//                     <ul className="ml-4 mt-2 space-y-2">
//                       {link.dropdown.map((item, i) => (
//                         <li key={i}>
//                           {item.url ? (
//                             <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>
//                               {item.name}
//                             </Link>
//                           ) : (
//                             <button onClick={item.action}>{item.name}</button>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   </details>
//                 ) : (
//                   <Link to={link.url} className="hover:text-lime-500" onClick={() => setIsMobileMenuOpen(false)}>
//                     {link.name}
//                   </Link>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </nav>
//     </>
//   );
// }

// export default Navbar;
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {

const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
const [user, setUser] = useState(initialUser || null);
const [userProfile, setUserProfile] = useState(initialUserProfile || null);
const navigate = useNavigate();

const getInitials = (user) => {
if (!user) return "";
if (user.firstName && user.lastName)
return user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase();
if (user.name)
return user.name.charAt(0).toUpperCase() + user.name.charAt(user.name.length - 1).toUpperCase();
return "";
};

const handleLogoutClick = () => {
localStorage.removeItem("auth");
setUser(null);
setUserProfile(null);
if (handleLogout) handleLogout();
navigate("/login");
};

useEffect(() => {
const auth = localStorage.getItem("auth");
if (auth) {
try {
const parsed = JSON.parse(auth);
const storedUser = parsed?.user;
if (storedUser) {
setUser(storedUser);
setUserProfile(storedUser);
}
} catch (error) {
console.error("Invalid auth data:", error);
}
}
}, []);


// BLINDS MENU
const blinds = [
{ name: "Roller Blinds", url: "/roller-blinds" },
{ name: "Vertical Blinds", url: "/vertical-blinds" },
{ name: "Roman Blinds", url: "/roman-blinds" },
{ name: "Wooden Blinds", url: "/wooden-blinds" },
{ name: "Venetian Blinds", url: "/venetian-blinds" },
{ name: "Blackout Blinds", url: "/blackout-blinds" },
];


// ROOMS MENU
const rooms = [
{ name: "Kitchen Blinds", url: "/kitchen-blinds" },
{ name: "Bedroom Blinds", url: "/bedroom-blinds" },
{ name: "Bathroom Blinds", url: "/bathroom-blinds" },
{ name: "Living Room Blinds", url: "/living-room-blinds" },
];


// GUIDES MENU
const guides = [
{ name: "How to Measure Blinds", url: "/how-to-measure-blinds" },
{ name: "How to Install Blinds", url: "/how-to-install-blinds" },
{ name: "How to Clean Blinds", url: "/how-to-clean-blinds" },
];

const aboutSection = [
{ name: "FAQs", url: "/faq" },
{ name: "Blog", url: "/blog" },
{ name: "Terms & Conditions", url: "/termsandconditions" },
];

const clientPortal = user
? [
userProfile?.role === "user" ? { name: "Book Now", url: "/book" } : null,
{ name: "Logout", action: handleLogoutClick },
].filter(Boolean)
: [
{ name: "Login", url: "/login" },
{ name: "Register", url: "/register" },
];

const navLinks = [
{ name: "Blinds", dropdown: blinds },
{ name: "Rooms", dropdown: rooms },
{ name: "Guides", dropdown: guides },
{ name: "About", dropdown: aboutSection },
{ name: "Client Portal", dropdown: clientPortal },
{ name: "Contact", url: "/contact" },
];

return (

<nav className="w-full bg-white shadow-md sticky top-0 z-50">

<div className="max-w-7xl mx-auto flex justify-between items-center px-6">

{/* LOGO */}

<Link to="/" className="flex items-center space-x-3">
<img src="/images/logi.png" className="w-28 h-28 object-contain" />
</Link>

{/* DESKTOP MENU */}

<ul className="hidden md:flex items-center space-x-8 mx-auto text-lg">

{navLinks.map((link, idx) => (

<li key={idx} className="relative group">

{link.dropdown ? (

<>

<button className="flex items-center gap-1 text-gray-900 hover:text-lime-600 font-semibold">

{link.name}

<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>

</svg>

</button>


{/* MEGA MENU */}

<div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-xl border rounded-lg p-6 w-[500px]">

<div className="grid grid-cols-2 gap-4">

{link.dropdown.map((item,i)=>(

<div key={i}>

{item.url ? (

<Link

to={item.url}

className="block px-3 py-2 rounded hover:bg-lime-500 hover:text-white transition"

>

{item.name}

</Link>

) : (

<button

onClick={item.action}

className="block px-3 py-2 rounded hover:bg-lime-500 hover:text-white w-full text-left"

>

{item.name}

</button>

)}

</div>

))}

</div>

</div>

</>

) : (

<Link to={link.url} className="text-gray-900 hover:text-lime-600 font-semibold">

{link.name}

</Link>

)}

</li>

))}

</ul>


{/* RIGHT SIDE */}

<div className="flex items-center space-x-3">

{user ? (

<Link to="/profile">

{userProfile?.avtar ? (

<img src={userProfile.avtar} className="w-10 h-10 rounded-full border-2 border-lime-500 object-cover"/>

) : (

<div className="w-10 h-10 flex items-center justify-center rounded-full bg-lime-500 text-white font-bold">

{getInitials(userProfile || user)}

</div>

)}

</Link>

) : (

<>

<Link to="/login" className="px-3 py-2 border border-lime-500 rounded hover:bg-lime-500 hover:text-white">

Login

</Link>

<Link to="/register" className="px-3 py-2 bg-lime-500 rounded text-white hover:bg-lime-600">

Signup

</Link>

</>

)}

<button

onClick={()=>setIsMobileMenuOpen(!isMobileMenuOpen)}

className="md:hidden text-lime-600"

>

<svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">

<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"/>

</svg>

</button>

</div>

</div>


{/* MOBILE MENU */}

{isMobileMenuOpen && (

<div className="md:hidden bg-white px-6 py-4 space-y-3">

{navLinks.map((link,idx)=>(

<div key={idx}>

{link.dropdown ? (

<details>

<summary className="cursor-pointer font-semibold">{link.name}</summary>

<ul className="ml-4 mt-2 space-y-2">

{link.dropdown.map((item,i)=>(

<li key={i}>

{item.url ? (

<Link to={item.url}>{item.name}</Link>

) : (

<button onClick={item.action}>{item.name}</button>

)}

</li>

))}

</ul>

</details>

) : (

<Link to={link.url}>{link.name}</Link>

)}

</div>

))}

</div>

)}

</nav>

);

}

export default Navbar;